<template>
  <section class="pb-[60px] xl:pb-[140px]" id="exchanges">
    <div class="container">
      <div
        class="download-bg relative w-full h-full px-6 pt-6 lg:p-10 rounded-3xl overflow-hidden"
      >
        <div class="relative z-10 text-center lg:text-left direction-ltr">
          <h3
            class="text-[28px] lg:text-[48px] text-white font-bold leading-[28px] lg:leading-[56px] lg:max-w-[400px]"
          >
            {{ $t("landing.download.title") }}
          </h3>
          <p class="text-white text-base mt-2 lg:max-w-[300px]">
            {{ $t("landing.download.description") }}
          </p>
          <div class="relative inline-flex lg:mt-10 my-6 lg:mb-0">
            <CommonQRDownload class="lg:block hidden" />
            <CommonUIDownload class="flex lg:hidden" />
          </div>
        </div>
        <img
          src="/landing/images/application.webp"
          alt="Applications"
          class="absolute w-[700px] h-[700px] top-[-140px] right-0 z-10 lg:block hidden"
        />
        <img
          src="/landing/images/application-mobile.webp"
          alt="Application"
          class="w-auto h-[280px] mx-auto lg:hidden block"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import CommonQRDownload from "@/modules/Landing/components/Common/QRDownload.vue";
import CommonUIDownload from "@/modules/Landing/components/Common/UIDownload.vue";
</script>

<style scoped>
.download-bg {
  background: linear-gradient(
    134.77deg,
    #0a241a -13.51%,
    #131c18 50.28%,
    #181a18 125.16%
  );
}
</style>
